import React from "react";
import { useNavigate } from "react-router-dom";

const NaytaPaluuNappi = ({ kohde = "/" }) => {
  const navigate = useNavigate();
  let title = "Palaa ";
  switch (kohde) {
    case "/kori":
      title = title + "koriin";
      break;
    case "-1":
      title = title + "kiekkoon";
      break;
    default:
      title = title + "tuotelistaan";
  }

  function handleClick(event) {
    navigate(kohde);
    document.documentElement.style.setProperty("--koriAnimaatio", "none");
  }
  return (
    <button
      className="nappi nappi3"
      autoFocus
      title={title}
      onClick={handleClick}
    >
      Palaa
    </button>
  );
};

export default NaytaPaluuNappi;
